import React from "react";
import {fetchData, putData} from '../awsFunctions';

// const fetchDataFormDynamoDb = () => {
//   fetchData('testTable')
// }

// const addDataToDynamoDB = async () => {
//   const userData = {
//     id:"7",
//   }
  
//   await putData('users' , userData)
// }

const Gallery = () => {
  return (
    <div>
      {/* <iframe src="https://calendar.google.com/calendar/embed?src=fancytickler7%40gmail.com&ctz=America%2FNew_York"></iframe> */}

    </div>
  );
};



export default Gallery;